import gql from 'graphql-tag';

export default gql`
  fragment CMSHighSchoolDetails on CmsHighSchool {
    id
    name
    field_hs_elna_school_type
    contact {
      field_hs_elna_address_line1
      field_hs_elna_state_latest
      field_hs_elna_city
      field_hs_el_county_name
      field_hs_eln_zip
      field_hs_na_country_name_ref
      field_hs_na_fax
      field_hs_elna_phone
      field_hs_na_url
    }
    enrollmentByGrade {
      field_hs_el_prekinder_students
      field_hs_el_kindergart_students
      field_hs_el_grade_1_students
      field_hs_el_grade_2_students
      field_hs_el_grade_3_students
      field_hs_el_grade_4_students
      field_hs_el_grade_5_students
      field_hs_el_grade_6_students
      field_hs_el_grade_7_students
      field_hs_el_grade_8_students
      field_hs_el_grade_9_students
      field_hs_el_grade_10_students
      field_hs_el_grade_11_students
      field_hs_el_grade_12_students
    }
    enrollmentByEthnicity {
      field_hs_el_asianpacificisl_stud
      field_hs_el_am_ind_alas_nat_stud
      field_hs_el_hawai_natpcfisl_stud
      field_hs_el_twoormore_races_stud
      field_hs_el_black_students
      field_hs_el_white_students
      field_hs_el_hispanic_students
    }
    enrollmentByGender {
      field_hs_el_female_students
      field_hs_el_male_students
      field_hs_el_nonbinary_students
    }
    academic {
      field_hs_el_titlei_school_status
      field_hs_el_titleieligible_schoo
      field_hs_el_years_sch_rep_data
      field_hs_el_school_type_public
      field_hs_el_school_type_private
      field_hs_el_fte_teachers
      field_hs_el_pupil_teacher_ratio
      field_hs_na_percent_college
      field_hs_el_coeducational
      field_hs_el_charter_school
      field_hs_elna_highest_grade
      field_hs_elna_lowest_grade
      field_hs_el_school_level
    }
  }
`;
